<template>
  <v-content>
    <v-container>
      <v-card
        flat
        outlined
        color="transparent"
      >
        <v-card-title>Contact</v-card-title>
        <v-divider />
        <v-card-text>

          
        </v-card-text>
        <v-row>
          <v-col md="6" sm="12">

            <p class="headline">President: David Ley</p>
            <p class="headline">Office Phone: 217-434-9106</p>
            <p class="headline">After Hours Phone: 217-617-7127</p>
            <p class="headline">Fax: 217-434-9122</p>
            <p class="headline">Address: 1468 Highway 24 Fowler, IL 62338</p>
            <p class="headline">Email: brandon@blitoolanddie.com</p>
            <br><br>
            <h3 class="headline font-weight-bold" style="color:#333333">Email to request a quote.</h3>

          </v-col>
          <v-col md="6" sm="12">
            <v-img
              src="logo.png"
                width="90%"
                height="auto"
                style="margin-left:10%;"
            />
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>


export default {
  name: 'contact',
  components: {

  },
  props: [

  ]
}
</script>

<style scoped>

</style>

<style src="../index.css"></style>